import React, { useState } from "react";
import Navbar from "../components/Navbar";
import Sidebar from "../components/Sidebar";
import InfoSection from "../components/InfoSection";
import ServicesSection from "../components/ServiceSection";
import {
  homeObjOne,
  homeObjThree,
} from "../components/InfoSection/Data";
import SignUp from "../components/SignUp";
// import Projects from "../components/Projects/Projects";
// import Proyectos from "../components/Proyectos/Proyectos";
import "react-toastify/dist/ReactToastify.css";

const Skillspage = () => {
  const [isOpen, setIsopen] = useState(false);

  const toogle = () => {
    setIsopen(!isOpen);
  };

  const [currentLanguage, setCurrentLanguage] = useState("es");

  const handleLanguageChange = (newLanguage) => {
    setCurrentLanguage(newLanguage);
  };

  return (
    <>
      <Sidebar isOpen={isOpen} toogle={toogle} />
      <Navbar
        toogle={toogle}
        isOpen={isOpen}
        currentLanguage={currentLanguage}
        onChangeLanguage={handleLanguageChange}
      />
   
      <InfoSection {...homeObjThree} />
      <InfoSection {...homeObjOne} />
      {/* // <Projects /> */}
      {/* <Proyectos /> */}
      <ServicesSection />
      <SignUp />
    </>
  );
};

export default Skillspage;
